import { StoreEntityType } from 'ngx-unificator/store';

export interface SpinWheelStore {
  currentPrize?: any;
  isTryTomorrow?: boolean;
  isIssuedBonus?: boolean;
  wheelData?: { rotated: number; img: string };
  spinTime?: number;
}

export const spinWheelStore: StoreEntityType<SpinWheelStore> = {
  currentPrize: null,
  isTryTomorrow: false,
  isIssuedBonus: false,
  wheelData: null,
  spinTime: null,
  __system: {
    persistence: 'localStorage',
    debug: false
  }
};

export type SpinWheelStoreEntity = typeof spinWheelStore;
